import React from 'react';
import WeatherScreen from '../screens/WeatherScreen';

export default function WeatherScanPage(): React.JSX.Element {
  return <WeatherScreen mode="page" />;
}
